export const RenderYouTubeVideo: React.FC<{ embedUrl: string }> = ({
  embedUrl,
}) => {
  return (
    <div className="video-wrapper">
      <iframe
        width="100%"
        height="400"
        src={embedUrl}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  );
};
